module.exports = __webpack_public_path__ + "img/logoWhite.847b2960.svg";